import React, { useEffect, useState } from "react";

import styled from "styled-components";
import { ButtonComponent, CheckboxComponent, TextField } from "../PrimeReact";
import Categores from "./categories";
import { MultiSelect } from "primereact/multiselect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

import {
  updateImage,
  deleteImage,
  buildImgProperties,
} from "../../imageResource";

const PictureGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2px 2px;
`;

const GridItem = styled.div`
  position: relative;
  display: flex;
  background-color: #2d2d2d;
  align-items: center;
  padding: 10px;
  ${(props) => (props.selected ? "background-color: #1188aa" : "")}
`;

const StyledImage = styled.img`
  width: 100%;
  display: block;
`;

const ImagePropertiesContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;

  background-color: #dedede;
  //color: white;

  display: flex;
  flex-direction: column;
  padding: 10px;
`;

const InnerContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;

  margin: 5px;

  flex-direction: row;

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (max-width: 450px) {
    flex-direction: column;
  }
`;

const StackedContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const DetailSpan = styled.div`
  font-size: 10px;
`;

const AbsoluteBottomRight = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0px;
  right: 0px;
  margin: 10px;
  width: 50px;
  height: 50px;
  //background-color: black;
  color: white;
  ${props => props.color && `color: ${props.color};`}
  font-size: 32px;
  overflow: hidden;
`

const ImageProperties = ({ image, updated }) => {
  const [subject, updateSubject] = useState(image);
  useEffect(() => {
    updateSubject(image);
  }, [image]);
  //console.log(image);

  const categories = Categores.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  //console.log(subject)

  const SaveChanges = () => {
    const updatedResult = {
      ...image,
      title: subject.title,
      caption: subject.caption,
      name: subject.name,
      public: subject.public,
      collections: subject.collections,
    };
    updateImage(image.id, updatedResult).then(() => updated(updatedResult));
  };

  return (
    <ImagePropertiesContainer>
      <InnerContainer>
        <TextField
          label="Title"
          value={subject.title}
          onChange={(e) => updateSubject({ ...subject, title: e.target.value })}
        ></TextField>
        <TextField
          label="Caption"
          value={subject.caption}
          onChange={(e) =>
            updateSubject({ ...subject, caption: e.target.value })
          }
        ></TextField>
        <TextField
          label="Name"
          value={subject.name}
          onChange={(e) => updateSubject({ ...subject, name: e.target.value })}
        ></TextField>
      </InnerContainer>
      <InnerContainer>
        <CheckboxComponent
          label={"Public"}
          checked={subject.public}
          onChange={(e) =>
            updateSubject({ ...subject, public: e.target.checked })
          }
        ></CheckboxComponent>
        <StackedContainer>
          <DetailSpan>{subject.hash}</DetailSpan>
          <DetailSpan>{subject.urls[0].url}</DetailSpan>
        </StackedContainer>
      </InnerContainer>
      <InnerContainer>
        <MultiSelect
          value={subject.collections}
          options={categories}
          onChange={(e) => updateSubject({ ...subject, collections: e.value })}
        />
        <ButtonComponent onClick={SaveChanges}>Save</ButtonComponent>
      </InnerContainer>
    </ImagePropertiesContainer>
  );
};

/*const buildImgProperties = (image) => {
  const src = image.urls.filter((item) => item.type === "default")[0].url;
  const baseForsrcSet = image.urls.filter((item) => !isNaN(item.type));

  let srcSet = [];
  for (let item of baseForsrcSet) {
    srcSet.push(`${item.url} ${item.type}w`);
  }

  return { src, srcset: srcSet.join(", "), srcSet: srcSet.join(", ") };
};*/

const PropertyEditor = ({ images, updated }) => {
  const [selected, setSelected] = useState(null);

  return (
    <>
      <PictureGrid>
        {images.map((image) => {
          const imageProps = buildImgProperties(image);
          return (
            <GridItem
              key={image._docId}
              onClick={() => setSelected(image._docId)}
              selected={selected === image._docId}
            >
              <StyledImage src={imageProps.src} srcSet={imageProps.srcSet} />
              <AbsoluteBottomRight color={!image.public ? "#ff0000" : "#00aa00"}>
                <FontAwesomeIcon icon={image.public ? faCheckCircle : faTimesCircle}></FontAwesomeIcon>
              </AbsoluteBottomRight>
            </GridItem>
          );
        })}
      </PictureGrid>

      {selected && (
        <ImageProperties
          image={images.filter((image) => image._docId === selected)[0]}
          updated={(image) => {
            setSelected(null);
            updated(image);
          }}
        ></ImageProperties>
      )}
    </>
  );
};

export default PropertyEditor;
